<!--
 * @Description: 新增编辑查看专题页弹框
 * @Author: wuxuebing
 * @Date: 2024-07-10 10:27:22
 * @LastEditors: wuxuebing
 * @LastEditTime: 2024-07-16 15:10:28
 * @FilePath: \ngs_platform_manage_admin\src\views\operation-management\topic-page-management\topic-page\components\add-dialog.vue
-->
<template>
	<el-dialog
		:before-close="dialogClose"
		class="custom-dialog"
		top="7vh"
		:close-on-click-modal="false"
		:destory-on-close="true"
		:title="dialogObj.title"
		:visible.sync="dialogObj.visible"
		width="600px"
	>
		<div class="pad-content">
			<el-form label-width="140px" :model="pageForm" :rules="pageRule" ref="pageRef">
				<el-form-item label="归属单位" prop="belongUnit">
					<el-input v-model="pageForm.belongUnit" :disabled="dialogObj.mode == 'view'" clearable placeholder="请输入"></el-input>
					<!-- <template v-if="dialogObj.mode == 'add'">
						<div @click="openUnit" class="input-box">
							<el-input v-model="pageForm.belongUnit" placeholder="请选择" maxlength="100"></el-input>
						</div>
					</template>
					<template v-else>
						<el-input v-model="pageForm.belongUnit" disabled></el-input>
					</template> -->
				</el-form-item>
				<el-form-item label="统一社会信用代码" prop="belongCode">
					<el-input v-model="pageForm.belongCode" :disabled="dialogObj.mode == 'view'" clearable placeholder="请输入"></el-input>
				</el-form-item>
				<el-form-item label="企业类型" prop="tenantType">
					<template v-if="dialogObj.mode !== 'view'">
						<el-select v-model="pageForm.tenantType" clearable>
							<el-option
								v-for="(item, index) in projectDict.qyztlx"
								:key="'ztlx' + index"
								:label="item.sname"
								:value="item.value"
							></el-option>
						</el-select>
					</template>
					<template v-else>
						<el-input v-model="pageForm.tenantTypeName" disabled></el-input>
					</template>
				</el-form-item>
				<el-form-item label="标签" prop="tenantTagArr">
					<template v-if="dialogObj.mode !== 'view'">
						<el-select v-model="pageForm.tenantTagArr" clearable multiple>
							<el-option
								v-for="(item, index) in projectDict.qybq"
								:key="'ztlx' + index"
								:label="item.sname"
								:value="item.value"
							></el-option>
						</el-select>
					</template>
					<template v-else>
						<el-input v-model="pageForm.tenantTagName" disabled></el-input>
					</template>
				</el-form-item>
				<el-form-item label="专题页路径">
					<el-input v-model="pageForm.pageUrl" disabled :placeholder="dialogObj.mode == 'add' ? '保存后自动生成' : ''"></el-input>
				</el-form-item>
				<el-form-item label="选择专题页模版" prop="temName">
					<template v-if="dialogObj.mode !== 'view'">
						<div @click="openTemplate" class="input-box">
							<el-input v-model="pageForm.temName" placeholder="请选择" maxlength="100"></el-input>
						</div>
					</template>
					<template v-else>
						<el-input v-model="pageForm.temName" disabled></el-input>
					</template>
				</el-form-item>
				<el-form-item label="状态" prop="status">
					<el-radio v-model="pageForm.status" :label="1" :disabled="dialogObj.mode == 'view'">启用</el-radio>
					<el-radio v-model="pageForm.status" :label="0" :disabled="dialogObj.mode == 'view'">禁用</el-radio>
				</el-form-item>
				<el-form-item label="备注">
					<el-input
						type="textarea"
						v-model="pageForm.remark"
						:rows="3"
						maxlength="200"
						show-word-limit
						clearable
						:disabled="dialogObj.mode == 'view'"
						:placeholder="dialogObj.mode == 'add' ? '请输入' : ''"
					></el-input>
				</el-form-item>
			</el-form>
		</div>

		<!--选择专题页归属单位弹框-->
		<el-dialog
			:title="unitDialog.title"
			:visible.sync="unitDialog.visible"
			:width="unitDialog.width"
			:close-on-click-modal="false"
			:before-close="unitDialogClose"
			append-to-body
		>
			<div class="search-box">
				<div class="search-unit">
					<div class="title">单位名称</div>
					<el-input v-model="searchObjUnit.sname" placeholder="请选择" maxlength="100"></el-input>
				</div>
				<div class="btn-box">
					<el-button @click="doRefreshUnit">重置</el-button>
					<el-button type="primary" class="btn-blue" @click="queryTenants('1')">搜索</el-button>
				</div>
			</div>
			<vxe-table
				align="center"
				height="400px"
				border
				:data="unitData"
				resizable
				ref="unitData"
				class="mt10"
				show-overflow="tooltip"
				show-header-overflow="tooltip"
				:row-config="{ keyField: 'tenantId', isCurrent: true }"
				:radio-config="{
					trigger: 'row',
					reserve: true,
					highlight: true,
					checkMethod: handleVisible
				}"
			>
				<vxe-column type="radio" width="60"></vxe-column>
				<vxe-table-column title="序号" width="100" type="seq"> </vxe-table-column>
				<vxe-table-column title="单位名称" field="sname" min-width="100" header-align="center" align="left"> </vxe-table-column>
				<vxe-table-column title="统一社会信用代码" field="creditCode" min-width="200" header-align="center" align="left"> </vxe-table-column>
				<vxe-table-column title="入驻日期" field="createDate" min-width="100" header-align="center" align="left"> </vxe-table-column>
				<vxe-table-column title="企业主" field="proprietor" min-width="100" header-align="center" align="left"> </vxe-table-column>
			</vxe-table>

			<div class="w-table-footer mt10">
				<vxe-pager
					size="mini"
					:current-page="searchObjUnit.currentPage"
					:page-size="searchObjUnit.pageSize"
					:total="searchObjUnit.totalResult"
					class="text-center"
					:page-sizes="[10, 20, 50, 100]"
					:layouts="['Total', 'Sizes', 'PrevPage', 'JumpNumber', 'NextPage', 'FullJump']"
					@page-change="handlePageChange"
				>
				</vxe-pager>
			</div>

			<!-- footer 组件 -->
			<div slot="footer" class="dialog-footer text-center">
				<el-button size="small" @click="unitDialogClose">取 消</el-button>
				<el-button type="primary" size="small" @click="saveUnit">确 定</el-button>
			</div>
		</el-dialog>

		<!--选择专题页模版弹框-->
		<el-dialog
			:title="templateDialog.title"
			:visible.sync="templateDialog.visible"
			:width="templateDialog.width"
			:close-on-click-modal="false"
			:before-close="templateClose"
			append-to-body
		>
			<vxe-table
				align="center"
				height="400px"
				border
				:data="templateData"
				resizable
				ref="templateData"
				class="mt10"
				show-overflow="tooltip"
				show-header-overflow="tooltip"
				:row-config="{ isCurrent: true }"
				:radio-config="{
					trigger: 'row',
					highlight: true
				}"
			>
				<vxe-column type="radio" width="60"></vxe-column>
				<vxe-table-column title="序号" width="100" type="seq"> </vxe-table-column>
				<vxe-table-column title="模板名称" field="sname" min-width="100" header-align="center" align="left"> </vxe-table-column>
				<vxe-table-column title="包含菜单" field="menus" min-width="200" header-align="center" align="left"> </vxe-table-column>
			</vxe-table>

			<!-- footer 组件 -->
			<div slot="footer" class="dialog-footer text-center">
				<el-button size="small" @click="templateClose">取 消</el-button>
				<el-button type="primary" size="small" @click="saveTemplate">确 定</el-button>
			</div>
		</el-dialog>

		<div slot="footer" class="pdb10 text-center">
			<el-button @click="dialogClose">取 消</el-button>
			<el-button type="primary" class="btn-blue" @click="dialogSubmit">确 定</el-button>
		</div>
	</el-dialog>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import * as API from 'api/modules/topicPage.js'
export default {
	components: {},
	data() {
		return {
			dialogObj: { title: '新增', type: 'add', visible: false, loading: false },
			pageForm: {
				id: '', // id
				belongCode: '', //  归属单位id
				belongUnit: '', // 归属单位名称
				tenantType: '', // 企业类型
				tenantTypeName: '', // 类型名称
				tenantTagArr: [], //标签
				tenantTag: '', // 标签str
				tenantTagName: '', // 标签名称
				pageUrl: '', // 专题页路径
				temId: '', // 专题页模板ID
				temName: '', // 专业页模板名称
				status: '', // 状态，1-启用，0-禁用
				remark: '', // 备注
				createUserid: '' //
			},
			pageRule: {
				belongUnit: [
					{
						required: true,
						message: '不能为空'
					}
				],
				belongCode: [
					{
						required: true,
						message: '不能为空',
						trigger: ['blur', 'change']
					}
				],
				tenantType: [
					{
						required: true,
						message: '不能为空',
						trigger: ['blur', 'change']
					}
				],
				tenantTagArr: [{ required: true, message: '不能为空', type: 'array', trigger: ['change', 'blur'] }],
				temName: [
					{
						required: true,
						message: '不能为空'
					}
				],
				status: [
					{
						required: true,
						message: '不能为空',
						trigger: 'change'
					}
				]
			},
			unitData: [], //  归属单位数据
			searchObjUnit: {
				sname: '', //
				currentPage: 1, // 当前页码
				pageSize: 10, // 当前每页条数
				totalResult: 0
			},
			unitDialog: {
				title: '选择专题页归属单位',
				mode: 'add',
				width: '1000px',
				visible: false,
				loading: false
			},

			templateDialog: {
				title: '选择专题页模版弹框',
				mode: 'add',
				width: '700px',
				visible: false,
				loading: false
			},

			templateData: [] // 模板表格数据
		}
	},
	methods: {
		/********************   准备工作   ********************/
		// 按钮操作
		openClick(type, row) {
			// 给弹框类型赋值
			this.dialogObj.mode = type

			switch (type) {
				// 新增操作
				case 'add':
					this.dialogObj.title = '新增'
					break
				// 编辑操作
				case 'edit':
					this.dialogObj.title = '编辑'
					Object.keys(this.pageForm).forEach((key) => {
						this.pageForm[key] = row[key]
					})
					this.pageForm.tenantTagArr = !!this.pageForm.tenantTag ? this.pageForm.tenantTag.split(',') : []
					break
				// 查看操作
				case 'view':
					this.dialogObj.title = '查看'
					Object.keys(this.pageForm).forEach((key) => {
						this.pageForm[key] = row[key]
					})
					this.pageForm.tenantTagArr = !!this.pageForm.tenantTag ? this.pageForm.tenantTag.split(',') : []
					break
			}
			this.dialogObj.visible = true
			this.$refs.pageRef && this.$refs.pageRef.clearValidate()
		},

		/********************   弹窗相关  ********************/
		// 弹窗关闭
		dialogClose() {
			this.$emit('closeDialog')
			Object.assign(this.$data, this.$options.data.call(this))
			this.$refs.pageRef && this.$refs.pageRef.resetFields()
			this.dialogObj.visible = false
		},

		// 弹窗保存
		dialogSubmit() {
			this.$refs.pageRef.validate((valid) => {
				if (valid) {
					let params = Object.assign({}, this.pageForm)
					params.pageUrl = `${process.env.VUE_APP_PAGE_URL}NgsAzcWeb/#/topicPageManagement/1/${this.pageForm.belongCode}`
					params.tenantTag = params.tenantTagArr.join(',')

					API.setNewPage(params).then((res) => {
						this.$message.success('保存成功！')

						this.dialogClose()
					})
				} else {
					this.$message.warning('请校验表单！')
				}
			})
		},

		/********************   打开归属单位弹框   ********************/
		// 打开归属单位
		openUnit() {
			this.unitDialog.visible = true
			this.queryTenants('1')
		},

		// 归属单位分页接口
		queryTenants(page) {
			if (page) {
				this.searchObjUnit.pageSize = 10
				this.searchObjUnit.currentPage = 1
			}
			let params = {
				size: this.searchObjUnit.pageSize, // 当前每页条数
				current: this.searchObjUnit.currentPage, // 当前页码
				sname: this.searchObjUnit.sname // 归属单位
			}

			API.queryTenants(params)
				.then((res) => {
					// 单位赋值
					this.unitData = res.data.records
					this.searchObjUnit.totalResult = parseInt(res.data.total)
					//   如果有归属单位，则进行数据回显
					if (this.pageForm.belongCode) {
						this.unitData.map((item) => {
							if (this.pageForm.belongCode == item.creditCode) {
								this.$nextTick(() => {
									this.$refs.unitData.setRadioRow(item)
								})
							}
						})
					}
				})
				.catch((err) => {})
		},

		// 单位单选框是否可以选中
		handleVisible({ row }) {
			// isOpen为0可以选择,为1不能选择
			return row.isOpen == 0
		},

		// 切换分页
		handlePageChange({ currentPage, pageSize }) {
			this.searchObjUnit.currentPage = currentPage
			this.searchObjUnit.pageSize = pageSize
			this.queryTenants()
		},

		// 归属单位关闭
		unitDialogClose() {
			this.unitDialog.visible = false
		},

		// 选择单位保存
		saveUnit() {
			// 当前页数据
			let record1 = this.$refs.unitData.getRadioRecord(false)
			//  除了当前页其他页勾选数据
			let record2 = this.$refs.unitData.getRadioReserveRecord(false)

			if (record1 || record2) {
				this.pageForm.belongCode = record1?.creditCode || record2?.creditCode
				this.pageForm.belongUnit = record1?.sname || record2?.sname
				// 关闭弹框
				this.unitDialog.visible = false
			} else {
				this.$message.warning('请选择专题页归属单位！')
			}
		},

		//刷新/重置
		doRefreshUnit() {
			this.searchObjUnit.pageSize = 10
			this.searchObjUnit.currentPage = 1
			this.searchObjUnit.sname = ''
			this.queryTenants()
		},

		/********************   打开专题页模板   ********************/
		openTemplate() {
			// 打开弹框
			this.templateDialog.visible = true
			// 获取分页接口
			this.getTopicTems()
		},

		// 归属单位分页接口
		getTopicTems() {
			API.getTopicTems({}).then((res) => {
				this.templateData = res.data
				if (this.pageForm.temId) {
					this.templateData.map((item) => {
						if (this.pageForm.temId == item.id) {
							this.$nextTick(() => {
								this.$refs.templateData.setRadioRow(item)
							})
						}
					})
				}
			})
		},

		// 模板关闭
		templateClose() {
			this.templateDialog.visible = false
		},

		// 模板保存
		saveTemplate() {
			// 选择的模板
			let record = this.$refs.templateData.getRadioRecord(false)

			if (record) {
				this.pageForm.temId = record?.id
				this.pageForm.temName = record?.sname
				// 关闭模板弹框
				this.templateDialog.visible = false
			} else {
				this.$message.warning('请选择专题页模版！')
			}
		}
	},
	computed: {
		...mapState('user', {
			userInfo: (state) => state.userInfo
		}),
		...mapState('dict', {
			projectDict: (state) => state.projectDict
		})
	}
}
</script>

<style lang="less" scoped>
.search-box {
	display: flex;
	justify-content: space-between;
	align-self: center;
	.search-unit {
		display: flex;

		.title {
			width: 80px;
			line-height: 40px;
		}
	}
}

.pad-content {
	padding: 0 50px 0 30px;
}
</style>
